import { $, throttle } from '../helper/utils';

const header = $('#header');
const headerHeight = header !== null ? header.offsetHeight : 0;
const treshold = headerHeight * 3;
let lastScroll = 0;
let smallHeader = false;
let timeout = null;

const hideHeader = () => {
  if (smallHeader === false) {
    return;
  }

  smallHeader = false;
  clearTimeout(timeout);
  timeout = null;
  requestAnimationFrame(() => {
    header.classList.remove('small');
  });
};

const scrollCheck = throttle(() => {
  const top = window.pageYOffset || document.documentElement.scrollTop;

  if (top < treshold) {
    if (top <= headerHeight || (top > lastScroll && smallHeader === true)) {
      hideHeader(top);
    }

    lastScroll = top;
    return;
  }

  // scroll up show
  if (top < (lastScroll - 20) && smallHeader === false) {
    smallHeader = true;
    timeout = setTimeout(() => {
      requestAnimationFrame(() => {
        header.classList.add('small');
      });
    }, 300);

    // scroll down hide
  } else if (top > (lastScroll + 20)) {
    hideHeader(top);
  }

  lastScroll = top;
}, 150);

export default function headerScroll() {
  window.addEventListener('scroll', scrollCheck);
}